import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Layout, { Content, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Button, ConfigProvider, Menu, theme } from "antd";
import { HddFilled, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MergeFilled, ShopFilled } from "@ant-design/icons";
import { useCallback, useState } from "react";
import logoImg from '../../assets/images/logos/ai-measure-logo.svg'
import { handleUnauthorized, PATH_INFO } from "../util/helper";

export function PageLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken()
  const navigate = useNavigate()
  const location = useLocation()

  const getSelectedKey = useCallback(() => {
    const pathMap = [
      { key: '1', paths: [PATH_INFO.COMPANY_LIST.PATH, PATH_INFO.COMPANY_MANAGE.PATH, PATH_INFO.COMPANY_INFO.PATH, PATH_INFO.COMPANY_DEVICES_LIST.PATH, PATH_INFO.COMPANY_DEVICE_MANAGE.PATH, PATH_INFO.COMPANY_MEASUREMENTS_LIST.PATH, PATH_INFO.DEPARTMENT_LIST.PATH, PATH_INFO.DEPARTMENT_MANEGE.PATH, PATH_INFO.DEPARTMENT_DETAIL.PATH, PATH_INFO.DEPARTMENT_USER_DETAIL.PATH, PATH_INFO.DEPARTMENT_USER_MANAGE.PATH] },
      { key: '2', paths: [PATH_INFO.DEVICE_LIST.PATH, PATH_INFO.DEVICE_MANAGE.PATH] },
      { key: '3', paths: [PATH_INFO.NAME_MATCHING.PATH] }
    ]

    const selectedKey = pathMap.find(({ paths }) =>
      paths.some((path) => location.pathname.startsWith(path.split('/:')[0]))
    )?.key

    return selectedKey ? [selectedKey] : []
  }, [location.pathname])

  const onClickCompany = useCallback(() => { navigate(PATH_INFO.COMPANY_LIST.PATH) }, [navigate])
  const onClickDevice = useCallback(() => { navigate(PATH_INFO.DEVICE_LIST.PATH) }, [navigate])
  const onClickNameMathing = useCallback(() => { navigate(PATH_INFO.NAME_MATCHING.PATH) }, [navigate])
  const onClickLogout = useCallback(async () => {
    await handleUnauthorized(navigate)
  }, [navigate])

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Noto Sans JP"
        }
      }}
    >
      <Layout className="h-screen font-noto">
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className='w-full h-[64px] flex items-center justify-center mb-5'>
            <img src={logoImg} alt="logo" className={`${collapsed && 'w-[65px]'}`} />
          </div>
          <div className="flex flex-col justify-between h-[calc(100%-84px)]">
            <div>
              <Menu
                theme="dark"
                mode="inline"
                selectedKeys={getSelectedKey()}
                items={[
                  {
                    key: '1',
                    icon: <ShopFilled />,
                    label: '企業管理',
                    onClick: onClickCompany,
                  },
                  {
                    key: '2',
                    icon: <HddFilled />,
                    label: 'デバイス管理',
                    onClick: onClickDevice,
                  },
                  {
                    key: '3',
                    icon: <MergeFilled />,
                    label: '名寄せ管理',
                    onClick: onClickNameMathing,
                  },
                ]}
              />
            </div>
            <div>
              <Menu
                className="mb-auto"
                theme="dark"
                mode="inline"
                selectable={false}
                items={[
                  {
                    key: 'logout',
                    label: 'ログアウト',
                    icon: <LogoutOutlined />,
                    onClick: onClickLogout
                  }
                ]}
              />
            </div>
          </div>
        </Sider>
        <Layout className="bg-gray-300 overflow-y-auto">
          <Header style={{ padding: 0, background: colorBgContainer, position: "sticky", top: 0, zIndex: 99 }} className="shadow-lg">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed((prev) => !prev)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
          </Header>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              borderRadius: borderRadiusLG,
            }}
            className="bg-gray-100 min-h-fit shadow-lg"
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}
